module.exports = __webpack_public_path__ + "img/pre-initiation_b_button.9823b5bd.png";